import { Dialog, DialogProps, DialogContent } from '@mui/material';
import { Color } from 'models';
import { StyledCard, BackButton, ArrowIcon, StyledCloseIcon } from './Modal.styles';

interface ModalProps extends DialogProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  fullScreen?: boolean;
  closeType?: 'back' | 'close' | 'none';
  iconColor?: Color;
}

const Modal = ({
  open,
  onClose,
  children,
  closeType = 'back',
  fullScreen = false,
  iconColor = 'light',
  ...rest
}: ModalProps) => {
  const ExitIcon = closeType === 'back' ? ArrowIcon : StyledCloseIcon;
  return (
    <Dialog open={open} onClose={onClose} scroll="body" fullScreen={fullScreen} {...rest}>
      <DialogContent>
        {closeType !== 'none' ? (
          <BackButton closetype={closeType} onClick={onClose} aria-label="Close modal">
            <ExitIcon iconcolor={iconColor} />
          </BackButton>
        ) : null}
        <StyledCard>{children}</StyledCard>
      </DialogContent>
    </Dialog>
  );
};

export default Modal;
